export enum PopupAlignment {
  left = 'left',
  right = 'right',
  custom = 'custom',
}

export enum PopupPlacement {
  top = 'top',
  bottom = 'bottom',
}

export interface PopupProps {
  alignment?: PopupAlignmentType
  children: React.ReactNode
  className?: string
  id?: string
  isOpen?: boolean
  onClickOutside?: (clickTarget?: Node) => void
  placement?: PopupPlacementType
  role?: string
  trigger: React.ReactNode
}

export type PopupAlignmentType = `${PopupAlignment}`
export type PopupPlacementType = `${PopupPlacement}`
